import { DriverEntity } from 'backend-entity';

export interface CrmGetRentDriversResponseDto {
  rows: DriverEntity[];
  total: number;
}
